import { z } from 'zod/v3';

export const SortSchema = z.object({
  empty: z.boolean(),
  sorted: z.boolean(),
  unsorted: z.boolean(),
});

export const createPaginationSchema = <ItemType extends z.ZodTypeAny>(
  itemSchema: ItemType,
) =>
  z.object({
    content: z.array(itemSchema),
    empty: z.boolean(),
    first: z.boolean(),
    last: z.boolean(),
    number: z.number(), // 0-based
    size: z.number(),
    totalElements: z.number(),
    totalPages: z.number(),
    sort: SortSchema,
  });

export const PageOfAnyRecordsSchema = createPaginationSchema(z.record(z.any()));
export type PageOfAnyRecordsType = z.output<typeof PageOfAnyRecordsSchema>;
